<script lang="ts">
	// Stores
	import { defaultStateType, getDeviceState } from 'src/stores/device-runtime/states';
	import { checkDeviceForceUpdate } from 'src/helpers/firmware_helpers';
	// Helpers
	// Components
	import PendingSleepAlert from 'src/components/Alerts/PendingSleepAlert.svelte';
	import DeviceStateView from 'src/components/Drawer/DeviceDrawer/DeviceStateView.svelte';
	// Types
	import type { Device } from 'src/types/Device';
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';

	/**
	 * Combined component for displaying device offline/loading states in sidepanel Main tabs.
	 *
	 * This component combines PendingSleepAlert and DeviceStateView to handle:
	 * - Offline devices
	 * - Calibrating devices
	 * - Firmware updating devices
	 * - Other loading states
	 * 	 *
	 * @prop device - The device object
	 * @prop status - Device status from devices_status store
	 * @prop hasAllData - Boolean indicating if all required data is available (computed in parent)
	 * @prop ignoreOfflineState - When true, the offline/loading overlay is skipped and the slot
	 *   content is rendered regardless of device state. Use for views whose data is not tied to
	 *   the device being online (e.g. cloud-stored camera recordings).
	 */
	export let device: Device;
	export let status: any;
	export let hasAllData: boolean;
	export let ignoreOfflineState = false;

	$: uiState = device?.id ? getDeviceState(device.id) : null;

	$: bypassBlockingForMandatoryUpdate = checkDeviceForceUpdate(device) && status?.online;
	$: isBlockingDeviceState =
		device?.id &&
		$uiState?.type !== undefined &&
		$uiState?.type < defaultStateType &&
		!bypassBlockingForMandatoryUpdate;
	$: showOfflineState = isBlockingDeviceState && !ignoreOfflineState;
</script>

{#if showOfflineState}
	<!-- <Container
		fullHeight
		noScroll
		class="flex-full-height align-items-center justify-content-center"
		padding="m"
	> -->
	<div class="flex-full-height align-items-center justify-content-center pl-m pr-m">
		<PendingSleepAlert {device} />
		<DeviceStateView {device} {status} uiState={$uiState} isV2Component={true} />
	</div>
	<!-- </Container> -->
{:else if hasAllData || ignoreOfflineState}
	<slot />
{:else}
	<div class="loading-state">
		<div class="flex-full-height"></div>
	</div>
{/if}
